import React, { useState } from "react";
import "./App.css";
import axios from "axios";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import Header from "./Header.js";
import Herosection from "./Herosection.js";
import Watch from "./Watch.js";

function App() {
  // const [data, setData] = useState([]);

  // const acceptdata = () => {
  //   const options = {
  //     method: "GET",
  //     url: "https://movies-api14.p.rapidapi.com/shows",
  //     headers: {
  //       "X-RapidAPI-Key": "921ba5b9b5msh3e5ab7a94ad0dc5p108eb8jsnd74af4c0acf7",
  //       "X-RapidAPI-Host": "movies-api14.p.rapidapi.com",
  //     },
  //   };

  //   axios
  //     .request(options)
  //     .then((res) => {
  //       console.log(res.data);
  //       setData(res.data.movies);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };

  // acceptdata()

  return (
    <>
      <Header />
      <Herosection />
      <Watch />
      <div>
        {/* <button
          className="btn btn-primary d-block mx-auto mt-4"
          onClick={acceptdata}
        >
          Get Data
        </button> */}
        {/* <div className="container-fluid">
          <div className="row">
            {data.map((val, key) => (
              <div className="col-12 col-xl-3 col-md-4 h-50" key={key}>
                <img
                  className="img-fluid"
                  src={val.backdrop_path}
                  alt="Image not found"
                />
                <img className="img-fluid" src={val.poster_path} />
                <p>{val.original_title}</p>
                <h2>{val.title}</h2>
                <p>
                  <b>OverView : </b>
                  {val.overview}
                </p>
                <p>{val.genres}</p>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </>
  );
}

export default App;
